// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PunxQ","controls":"styles_controls__1VVTG","charLimit":"styles_charLimit__ytjJm","input":"styles_input__3JV9P","send":"styles_send__3yWro"};